"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getAgeRequirementsString = function (admissionRequirements) {
    var _a;
    if (admissionRequirements === void 0) { admissionRequirements = {}; }
    if (!admissionRequirements.minAge && !admissionRequirements.maxAge)
        return '';
    var reqString = "".concat(admissionRequirements.minAge);
    if (admissionRequirements.maxAge == admissionRequirements.minAge) {
        return "".concat(reqString, " years old");
    }
    if (((_a = admissionRequirements.maxAge) === null || _a === void 0 ? void 0 : _a.toString()) != 'none' &&
        admissionRequirements.maxAge) {
        reqString = "".concat(reqString, "-").concat(admissionRequirements.maxAge, " years old");
    }
    else {
        reqString = "".concat(reqString, " and up");
    }
    return reqString;
};
exports.default = getAgeRequirementsString;
